module.exports = __webpack_public_path__ + "static/media/comebien.b13b909c.svg";